import { render, staticRenderFns } from "./NewTherapy.vue?vue&type=template&id=04c7cfc0"
import script from "./NewTherapy.vue?vue&type=script&lang=js"
export * from "./NewTherapy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports